"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpoundType = void 0;
var ImpoundType;
(function (ImpoundType) {
    ImpoundType["propertyTax"] = "propertyTax";
    ImpoundType["hazardInsurance"] = "hazardInsurance";
    ImpoundType["floodInsurance"] = "floodInsurance";
})(ImpoundType || (exports.ImpoundType = ImpoundType = {}));
